import produce from "immer";
import React, { useEffect, useMemo, useState } from "react";
import TreeAPI from "../apis/TreeAPI";

const useCourses = () => {
  const [courses, setCourses] = useState({});

  useEffect(() => {
    const unsubscribe = TreeAPI.subscribeToCourses(
      (course) =>
        setCourses(
          produce((draft) => {
            const { id, ...rest } = course;
            draft[id] = rest;
          })
        ),
      (courseId) =>
        setCourses(
          produce((draft) => {
            draft[courseId] = undefined;
          })
        )
    );

    return () => unsubscribe();
  }, []);

  const coursesArray = useMemo(() => {
    const keys = Object.keys(courses);

    const array = keys
      .filter((key) => courses[key] !== undefined)
      .map((key) => {
        const episodesArray = Object.keys(courses[key]?.episodes || {});
        return { id: key, ...courses[key], episodes: episodesArray };
      })
      .sort((a, b) => a.order - b.order);

    return array;
  }, [courses]);

  return {
    courses: coursesArray,
  };
};

// const dump = {
//   "5312c932-494b-4d0e-88f6-f418643e03ad": {
//     title: "Curso 1",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F312a4abb-a610-414c-af16-b61c6c31857b.jpg?alt=media&token=17157e13-3293-4b48-86b7-a51a1ad84eb3",
//     order: 0,
//     episodes: {
//       "93b885adfe0da089cdf634904fd59f71": true,
//       "1774360a6bb6ceeff99b0a2e7864b2d1": true,
//       "3485174357449b4f1fe23f9f521483b2": true,
//     },
//   },
//   "ddba5525-6252-4ece-90e1-6b23074736ad": {
//     title: "Curso 2",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F76a9097d-37e8-4766-bfe4-f8e14caf677c.jpg?alt=media&token=d96ee9f5-d309-4b00-8301-07086cdce902",
//     order: 1,
//     episodes: {
//       "e7913e95-c510-4a89-8b31-a0698f2fe122": true,
//       "7b8f3b6b-4aab-4bd4-9ae2-62d59b3a86d8": true,
//       "a42312ea-b7ac-4beb-b294-44843372b702": true,
//       "337b24b9-1726-41ac-8fe2-88e9d04f4eb8": true,
//       "da567e84-17e9-45b4-9cee-91fd2aeb24da": true,
//       "0ebe3f8b-f982-4b88-9d7b-4957404c09ad": true,
//       "dc519550-408e-4b0b-939e-4d0899640b50": true,
//       "40c91706-844e-4b89-9df3-8000dd821b44": true,
//     },
//   },
//   "357c6517-7746-449d-a3a9-42b75158af5a": {
//     title: "Curso 3",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2Fab91a0a7-2b0c-4a2b-ba58-d85d4ab1332f.jpg?alt=media&token=30016289-eaca-40eb-b59a-da9e107e543d",
//     order: 2,
//     episodes: {
//       ab6451b4fe7c789a15d876681d09c751: true,
//       "8f3cb4689f18ae17d88869243f277690": true,
//       "4d27bb9b-1b9d-4d63-a3e7-6d87a35d2c64": true,
//     },
//   },
// };

// const dataTest = {
//   "001": {
//     title: "Alemán para niños",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F312a4abb-a610-414c-af16-b61c6c31857b.jpg?alt=media&token=17157e13-3293-4b48-86b7-a51a1ad84eb3",
//     order: 0,
//     episodes: {
//       "93b885adfe0da089cdf634904fd59f71": true,
//       "1774360a6bb6ceeff99b0a2e7864b2d1": true,
//       "3485174357449b4f1fe23f9f521483b2": true,
//       "e7913e95-c510-4a89-8b31-a0698f2fe122": true,
//     },
//   },
//   "002": {
//     title: "Alemán para turistas",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F76a9097d-37e8-4766-bfe4-f8e14caf677c.jpg?alt=media&token=d96ee9f5-d309-4b00-8301-07086cdce902",
//     order: 1,
//     episodes: {
//       "7b8f3b6b-4aab-4bd4-9ae2-62d59b3a86d8": true,
//       "a42312ea-b7ac-4beb-b294-44843372b702": true,
//       "337b24b9-1726-41ac-8fe2-88e9d04f4eb8": true,
//     },
//   },
//   "003": {
//     title: "Alemán para negocios",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2Fab91a0a7-2b0c-4a2b-ba58-d85d4ab1332f.jpg?alt=media&token=30016289-eaca-40eb-b59a-da9e107e543d",
//     order: 2,
//     episodes: {
//       "da567e84-17e9-45b4-9cee-91fd2aeb24da": true,
//       "0ebe3f8b-f982-4b88-9d7b-4957404c09ad": true,
//     },
//   },
//   "004": {
//     title: "Alemán básico",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F7a59cdc7-2588-4dcb-8165-43801562abb9.jpg?alt=media&token=125eb471-6b17-4ecf-97d3-38922cef0e40",
//     order: 3,
//     episodes: {
//       "dc519550-408e-4b0b-939e-4d0899640b50": true,
//       "40c91706-844e-4b89-9df3-8000dd821b44": true,
//       ab6451b4fe7c789a15d876681d09c751: true,
//     },
//   },
//   "005": {
//     title: "Alemán intermedio",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F1d9b9cb8-c3b8-421c-bad5-7bf7a077b986.jpg?alt=media&token=e4c6b7d5-e89f-4cb1-92e3-65635f37ad96",
//     order: 4,
//     episodes: {
//       "8f3cb4689f18ae17d88869243f277690": true,
//       "4d27bb9b-1b9d-4d63-a3e7-6d87a35d2c64": true,
//     },
//   },
//   "006": {
//     title: "Alemán avanzado",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F19a71230-6482-4a4c-a63d-bdfa79ddc252.jpg?alt=media&token=d7cce38e-995b-4cc0-a054-79de3bf1064a",
//     order: 5,
//     episodes: {
//       "79dcce4e-0d7b-4334-a698-726b9d5d99b2": true,
//       "c546019d-76d1-4455-a46a-078ad49a7649": true,
//     },
//   },
// };

export { useCourses };
